<ion-header>
  <ion-toolbar>
    <ion-title>Feature Group</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>

  <!-- <div sxPadding="medium" sxCol sxGap="10px">
    <super-input label="Name" [(value)]="featureGroup.name"></super-input>
    <super-input label="Description" [(value)]="featureGroup.description"></super-input>
    <super-button [action]="update" al>Update</super-button>
  </div> -->

</ion-content>
